module.exports = __webpack_public_path__ + "media/images/icon_arrow-circle-cb5d5bf7b348d04c91ed513c43e9bf27.svg";